<template>
    <div class="bg_account">
        <mainMenu />
        <div class="container">
            <div class="width100 d-flex justify-content-center align-items-center">
                <div class="col-lg-6 ">
                    <b-card class="my-5 mx-auto " header="404">
                        <b-card-text>
                            Страница не найдена.
                        </b-card-text>
                    </b-card>
                </div>
            </div>
            <cabinetFooter />
        </div>
    </div>
</template>
<script>
import cabinetFooter from '@/components/cabinetFooter.vue'
import mainMenu from '@/components/mainMenu.vue'

export default {
    data() {
        return {
            form: {
                email: '',
            }
        }
    },
    components: {
        cabinetFooter,
        mainMenu
    },
    mounted() {
        if (this.$route.path == '/account/recovery') {
            document.title = 'Восстановление пароля';
        }
    },
    methods: {
        onSubmit(event) {
            event.preventDefault()
            alert(JSON.stringify(this.form))
        },
        onReset(event) {
            event.preventDefault()
            this.form.email = ''
        }
    }
}
</script>
<style></style>